import React from 'react';
import { Box, Flex, Heading, HStack, Icon, Link, Text, VStack } from '@televet/kibble-ui';
import { Browsers } from 'shared/enums/Browsers';
import checkBrowserSupport from 'shared/components/UnsupportedBrowserPopover/checkBrowserSupport';

const { browser } = checkBrowserSupport();

const browserPermissionInfoLinks: Record<string, string> = {
  [Browsers.Chrome]: 'https://support.google.com/chrome/answer/114662?co=GENIE.Platform%3DDesktop&hl=en',
  [Browsers.Edge]:
    'https://www.windowscentral.com/how-manage-site-permissions-new-microsoft-edge#set_site_permissions_edge_chromium',
  [Browsers.Firefox]:
    'https://support.mozilla.org/en-US/kb/how-manage-your-camera-and-microphone-permissions#w_changing-camera-permissions',
  [Browsers.MobileSafari]:
    'https://wccftech.com/how-to/access-website-camera-microphone-location-permissions-in-safari-for-ios-13-ipados/;',
  [Browsers.Safari]:
    'https://support.apple.com/guide/safari/websites-ibrwe2159f50/mac#:~:text=To%20change%20these%20preferences%2C%20choose,menu%20next%20to%20the%20website.',
};

const MicrophoneBlockedAlert = ({ closeButton }: { closeButton: JSX.Element }): JSX.Element => {
  return (
    <VStack spacing={2} align="stretch" p={4}>
      <HStack spacing={2}>
        <Icon name="warningSign" variant="danger" size="md" />
        <Heading size="md">Microphone Disabled</Heading>
        <Flex flex="1 1 auto" justify="flex-end" align="flex-start">
          {closeButton}
        </Flex>
      </HStack>
      <Text>To make phone calls, please allow this site to access your microphone then refresh the page.</Text>
      <Box>
        <Link target="_blank" rel="noopener noreferrer" href={browserPermissionInfoLinks[browser]}>
          Click here to view help
        </Link>{' '}
        with changing your permissions in {browser}.
      </Box>
    </VStack>
  );
};

export default MicrophoneBlockedAlert;
